<template>
  <div class="page-transition" :style="{ height: modalHeight, 'overflow': modalHeight ? 'hidden' : ''}" ref="transtionWrap">
    <transition :name="transitionName" @before-enter="updateHeight" @after-enter="resetHeight">
      <div :key="page" class="page-transition-body" ref="transtionBody">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    transitionName: {
      type: String,
      default: 'slide-left',
    },
    page: Number,
  },
  data() {
    return {
      modalHeight: undefined,
    };
  },
  computed: {},
  created() {},
  methods: {
    updateHeight() {
      // 设置为前一个页面的高度
      this.modalHeight = `${this.$refs.transtionBody.offsetHeight}px`;
      // 动态计算当前步骤内容的高度，然后设置成后一个
      this.$nextTick(() => {
        this.modalHeight = `${this.$refs.transtionBody.offsetHeight}px`;
      });
    },
    resetHeight() {
      // 动画结束后重置高度为 auto，允许内容根据需要伸缩
      this.modalHeight = undefined;
    },
  },
};
</script>

<style lang="less" scoped>
.page-transition{
  width: 100%;
  position: relative;
  transition: height 0.3s ease;
  .page-transition-body{
    width: 100%;
  }
}

/* 过渡动画 */
.slide-left-enter-active, .slide-left-leave-active {
  transition: all 0.3s ease;
  position: absolute;
  left: 0;
  top: 0;
}
.slide-left-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-left-leave, .slide-left-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.slide-right-enter-active, .slide-right-leave-active {
  transition: all 0.3s ease;
  position: absolute;
  left: 0;
  top: 0;
}
.slide-right-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.slide-right-leave, .slide-right-enter-to {
  transform: translateX(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/created-order/components/page-transtion.vue